import {useCallback, useState} from 'react';
import type {Job} from '@cp/model';
import {jobCreateQuestionShuffle} from '../../api/callable/jobs';

/**
 * Hook for creating question shuffle jobs
 * This will create a background job to shuffle questions for specified topics and difficulties
 */
export function useCreateQuestionShuffleJob() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>(undefined);

  const createQuestionShuffleJob = useCallback(
    async (moduleId: string, topics?: string[], difficulties?: number[]): Promise<Job> => {
      setLoading(true);
      setError(undefined);
      try {
        return await jobCreateQuestionShuffle({moduleId, topics, difficulties});
      } catch (err) {
        const e = err instanceof Error ? err : new Error(String(err));
        setError(e);
        throw e;
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  return {
    createQuestionShuffleJob,
    loading,
    error,
  };
}
